import React from 'react';
import { scoreColor } from './diagnosticHelpers';

// Reusable horizontal progress bar used across knowledge, behaviour and topic sections.
const ProgressBar = ({ value = 0, color, height = 8, showTrack = true }) => {
  const v = Math.min(Math.max(Number(value) || 0, 0), 100);
  const fill = color || scoreColor(v);
  return (
    <div
      className="dxr-bar-track"
      style={{ height, background: showTrack ? '#eeecf9' : 'transparent' }}
      role="progressbar"
      aria-valuenow={Math.round(v)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div className="dxr-bar-fill" style={{ width: `${v}%`, background: fill, height }} />
    </div>
  );
};

export default ProgressBar;
